import styled from "styled-components";
import { AdminContent } from "../adminRoutes.style";

export const AdminTourDashboardContent = styled(AdminContent)`
  max-width: 120rem;
  padding: 0;
`;
